// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2UgYO","col":"styles_col__1QdOj"};